import Icon from 'components/atoms/Icon';
import {
  FieldArray,
  FieldArrayRenderProps,
  useField,
  useFormikContext,
} from 'formik';
import { TEditSoftSkillFormValues } from 'views/StaticContent/SoftSkills/drawers/SoftSkillDrawer.helpers';
import { Button, FormikTextInputField } from '@spotted-zebra-uk/ui-components';
import styles from './SoftSkillExamples.module.scss';
import SoftSkillTabSection from './SoftSkillTabSection';

type SoftSkillExamplesProps = {
  isEditMode?: boolean;
};

export function SoftSkillExamples({ isEditMode }: SoftSkillExamplesProps) {
  const { values } = useFormikContext<TEditSoftSkillFormValues>();

  const onAddExample = (fieldArrayHelpers: FieldArrayRenderProps) => {
    fieldArrayHelpers.push('');
  };

  return (
    <SoftSkillTabSection
      title="Examples"
      description="Example behaviours that demonstrate this skill. If added, they will appear in skills evaluations where this skill is included, provided skills evaluation guidance is enabled."
      hasNoItems={values.examples?.length === 0 && !isEditMode}
      noItemLabel="examples"
    >
      <FieldArray
        name={'examples'}
        render={fieldArrayHelpers => (
          <div className={styles.softSkillExamplesContainer}>
            {isEditMode ? (
              <>
                <div className={styles.examplesContainer}>
                  {values.examples?.map((_, idx) => (
                    <div key={idx} className={styles.softSkillExampleRow}>
                      <FormikTextInputField
                        className={styles.editExample}
                        label="Example"
                        type="text"
                        id={`examples.${idx}`}
                        useFormikField={useField}
                      />

                      <Button
                        onClick={() => {
                          fieldArrayHelpers.remove(idx);
                        }}
                        size="medium"
                        variant="negative"
                        type="button"
                        disabled={values.examples?.length === 0}
                        leftIcon={
                          <Icon icon="delete_outline" className={styles.icon} />
                        }
                      />
                    </div>
                  ))}
                </div>
                <Button
                  className={styles.addExampleButton}
                  onClick={() => onAddExample(fieldArrayHelpers)}
                  size="medium"
                  variant="secondary"
                  type="button"
                  leftIcon={<Icon icon="add" className={styles.icon} />}
                >
                  Add
                </Button>
              </>
            ) : (
              <ul className={styles.examplesList}>
                {values.examples?.map((example, idx) => (
                  <li key={idx} className={styles.exampleItem}>
                    {example}
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      />
    </SoftSkillTabSection>
  );
}
